// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__6vgJg","modal":"Modal_modal__2ST0l","slide-down":"Modal_slide-down__t15la"};